import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { MenuService } from '../theme/components/menu/menu.service';
import { SubscriptionsContainer } from '../theme/utils/subscriptions-container';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    providers: [MenuService],
    standalone: false
})
export class PagesComponent implements OnInit {
  @ViewChild('backToTop') backToTop: any;
  @ViewChild('mainContent') mainContent: ElementRef;

  public settings: Settings;
  public sidenavOpen: boolean = true;
  public showInfoContent: boolean = false;
  public pageTitle: string = '';

  subs = new SubscriptionsContainer();
  isHomolog: boolean = environment.isHomolog;

  constructor(
    public appSettings: AppSettings,
    public router: Router,
    private menuService: MenuService
  ) {
    this.settings = this.appSettings.settings;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.pageTitle = this.resolvePageTitle(this.router.routerState.snapshot.root);
      }
    });
  }

  private resolvePageTitle(node: ActivatedRouteSnapshot): string {
    const labels: string[] = [];
    const toLabel = (b: any): string => (typeof b === 'string' ? b : (b?.label ?? ''));
    const collect = (n: ActivatedRouteSnapshot) => {
      const crumb = n.data['breadcrumb'];
      if (crumb) {
        const items: any[] = Array.isArray(crumb) ? crumb : [crumb];
        items.forEach(b => {
          const label = toLabel(b);
          if (label) labels.push(label);
        });
      }
      if (n.firstChild) collect(n.firstChild);
    };
    collect(node);
    return labels.length ? labels[labels.length - 1] : '';
  }

  ngOnInit() {
    if (window.innerWidth <= 1279) {
      this.sidenavOpen = false;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => { this.settings.loadingSpinner = false; }, 300);

    this.backToTop.nativeElement.style.display = 'none';

    this.subs.add = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      }
      if (window.innerWidth <= 1279) {
        this.sidenavOpen = false;
      }
    });

    if (this.settings.menu === 'vertical') {
      this.menuService.expandActiveSubMenu(this.menuService.getMenu());
    }
  }

  ngOnDestroy() {
    this.subs.dispose();
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    this.sidenavOpen = window.innerWidth > 1279;
  }

  public onScroll(event: Event) {
    const scrollTop = (event.target as HTMLElement).scrollTop;
    this.backToTop.nativeElement.style.display = scrollTop > 300 ? 'flex' : 'none';
  }

  public scrollToTop() {
    if (this.mainContent?.nativeElement) {
      this.mainContent.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  public closeSubMenus() {
    if (this.settings.menu == 'vertical') {
      this.menuService.closeAllSubMenus();
    }
  }
}
